import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";

export default function DigitalDownloadsAdmin() {
  // CONSTANTS
  const { download_id, page } = useParams();

  return (
    <Container>
      <h3 className="text-white">DigitalDownloadsAdmin</h3>
      <p className="text-white">{download_id}</p>
      {page && <p className="text-white">{page}</p>}
    </Container>
  );
}
